import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Прокрутка вверх при смене страницы
  }, [pathname]);

  return null;
}

export default ScrollToTop;
